<script>
  import { getPosts } from "../getPosts.js";
  import { store } from "../store.js";

  let types =
    $store.options[$$props.id].filtresParDefaut.type_contenus.split(",");

  async function primary_filters(filtre) {
    $store.options[$$props.id].loading = true;

    $store.options[$$props.id].filtres.type_contenus = filtre;
    $store.options[$$props.id].filtres.page = 1;

    let params = new URLSearchParams(
      $store.options[$$props.id].filtres
    ).toString();

    let myPosts = await getPosts(params);
    $store.posts[$$props.id] = myPosts;
    $store.options[$$props.id].found_posts = myPosts.found_posts;
    $store.options[$$props.id].max_num_pages = myPosts.max_num_pages;
    $store.options[$$props.id].loading = false;
  }
</script>

{#if types.length > 1}
  <div class="cs_primary_filters">
    <button
      class="filter-button tout {$store.options[$$props.id].filtres
        .type_contenus ===
      $store.options[$$props.id].filtresParDefaut.type_contenus
        ? 'active'
        : ''} {$store.options[$$props.id].filtres.mode === 'list'
        ? 'disabled'
        : ''}"
      on:click={() =>
        primary_filters(
          $store.options[$$props.id].filtresParDefaut.type_contenus
        )}>Tout voir</button
    >
    {#if types.includes("post")}
      <button
        class="filter-button actualites {$store.options[$$props.id].filtres
          .type_contenus === 'post'
          ? 'active'
          : ''} {$store.options[$$props.id].filtres.mode === 'list'
          ? 'disabled'
          : ''}"
        on:click={() => primary_filters("post")}>Actualités</button
      >
    {/if}
    {#if types.includes("evenement")}
      <button
        class="filter-button evenements {$store.options[
          $$props.id
        ].filtres.type_contenus.includes('evenement') &&
        !$store.options[$$props.id].filtres.type_contenus.includes('post')
          ? 'active'
          : ''}"
        on:click={() => primary_filters("evenement")}>Événéments</button
      >
    {/if}
    {#if types.includes("formation")}
      <button
        class="filter-button formations {$store.options[
          $$props.id
        ].filtres.type_contenus.includes('formation') &&
        !$store.options[$$props.id].filtres.type_contenus.includes('post')
          ? 'active'
          : ''}"
        on:click={() => primary_filters("formation")}>Formations</button
      >
    {/if}
  </div>
{/if}
